export default __webpack_public_path__ + "static/media/dmt-plumbing.cb7a5974.png";